module.exports = __webpack_public_path__ + "media/svg/calendar-e1eb9e7a.svg";